import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { adminPaymentReportDaily } from "../../api";
import ReportTablePage from "../../components/admin/ReportTablePage";

function todayStr() {
  return new Date().toISOString().slice(0, 10);
}

export default function PaymentReportDay() {
  const [loading, setLoading] = useState(false);
  const [template, setTemplate] = useState("perumahan");
  const [dateValue, setDateValue] = useState(todayStr());
  const [search, setSearch] = useState("");
  const [summary, setSummary] = useState({
    period: todayStr(),
    total_count: 0,
    total_amount: 0,
  });
  const [kawasanSummary, setKawasanSummary] = useState([]);
  const [items, setItems] = useState([]);

  const load = async () => {
    try {
      setLoading(true);
      const res = await adminPaymentReportDaily({
        template,
        date: dateValue,
      });

      setSummary(res?.summary || {
        period: dateValue,
        total_count: 0,
        total_amount: 0,
      });

      setKawasanSummary(Array.isArray(res?.kawasan_summary) ? res.kawasan_summary : []);
      setItems(Array.isArray(res?.items) ? res.items : []);
    } catch (e) {
      console.error(e);
      await Swal.fire({
        icon: "error",
        title: "Gagal",
        text: e?.response?.data?.error || "Gagal load laporan bayaran harian.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [template, dateValue]);

  return (
    <ReportTablePage
      title="Laporan Bayaran Harian"
      subtitle="Rekod bayaran mengikut hari."
      loading={loading}
      template={template}
      setTemplate={setTemplate}
      dateMode="date"
      dateValue={dateValue}
      setDateValue={setDateValue}
      search={search}
      setSearch={setSearch}
      summary={summary}
      kawasanSummary={kawasanSummary}
      items={items}
      onRefresh={load}
      itemColumns={[
        { key: "no_akaun", label: "No Akaun" },
        { key: "nombor_unit", label: "Unit" },
        { key: "kawasan", label: "Kawasan" },
        {
          key: "paid_at",
          label: "Tarikh Bayar",
          render: (v) => (v ? new Date(v).toLocaleString() : "-"),
        },
        {
          key: "amount",
          label: "Jumlah (RM)",
          render: (v) => Number(v || 0).toFixed(2),
        },
        { key: "receipt_no", label: "Receipt" },
      ]}
    />
  );
}